(()=>{
  'use strict';
  const CART_KEY = 'pb_cart_v1';
  const getCart = () => { try { return JSON.parse(sessionStorage.getItem(CART_KEY)||'[]'); } catch(e){ return []; } };
  const saveCart = (items) => sessionStorage.setItem(CART_KEY, JSON.stringify(items||[]));
  const addItem = (item) => { const items = getCart(); items.push(item); saveCart(items); dispatchEvent(new CustomEvent('pb:cart:update',{detail:items})); };
  const removeItem = (idx) => { const items = getCart(); items.splice(idx,1); saveCart(items); dispatchEvent(new CustomEvent('pb:cart:update',{detail:items})); };
  const clear = () => { saveCart([]); dispatchEvent(new CustomEvent('pb:cart:update',{detail:[]})); };
  window.PBCart = { getCart, addItem, removeItem, clear };
})();

